<template>
  <div>
    <v-layout v-if="loading" row justify-center align-center>
      <v-progress-circular
        :size="70"
        class="mt-10"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-layout>
    <h2>{{ this.properties.title }}</h2>
    <v-form ref="form" lazy-validation class="mr-2 scrollList-addLocation">
      <v-flex xs12>
        <!--        <v-expansion-panel>-->
        <!--          <v-expansion-panel-content v-for="(item,i) in 1" :key="i">-->
        <v-text-field
          v-if="editMode"
          slot="header"
          v-model="form.name"
          :label="$translate('TITLE')"
        ></v-text-field>

        <v-text-field
          v-else
          v-model="form.name"
          :label="$translate('TITLE')"
          required
          counter="128"
          value="2"
          slot="header"
          :rules="textRule"
          :disabled="searchingOsm"
        ></v-text-field>
        <!--            <div v-if="!editMode" class="outline-osm pl-1 pr-1">-->
        <!--              <h3>{{$translate('SEARCH_OSM')}}</h3>-->
        <!--              <v-text-field-->
        <!--                class="mb-2"-->
        <!--                label="Tags"-->
        <!--                v-model="query_tags"-->
        <!--                hint="format: tag1,tag2"-->
        <!--                :disabled="searchingOsm"-->
        <!--                persistent-hint-->
        <!--              ></v-text-field>-->
        <!--              <v-radio-group v-model="osmType" :disabled="searchingOsm">-->
        <!--                <v-radio color="primary" label="Way" value="way"></v-radio>-->
        <!--                &lt;!&ndash; <v-radio color="primary" label="Relation" value="relation"></v-radio> &ndash;&gt;-->
        <!--                <v-radio color="primary" label="Node" value="node"></v-radio>-->
        <!--              </v-radio-group>-->
        <!--              <v-flex class="text-xs-right">-->
        <!--                <v-tooltip bottom>-->
        <!--                  <v-btn round slot="activator" class="v-btn-2" @click="searchOSRM" color="primary">-->
        <!--                    <v-icon>search</v-icon>-->
        <!--                  </v-btn>-->
        <!--                  <span>{{$translate('SEARCH_OSM')}}</span>-->
        <!--                </v-tooltip>-->
        <!--              </v-flex>-->
        <!--              <v-progress-linear v-if="searchingOsm" color="primary" :indeterminate="true"></v-progress-linear>-->

        <!--              <OsmResult-->
        <!--                v-if="showOsmResult"-->
        <!--                :searchedLocations="searchedLocations"-->
        <!--                :type="osmType"-->
        <!--              ></OsmResult>-->
        <!--            </div>-->
        <!--          </v-expansion-panel-content>-->
        <!--        </v-expansion-panel>-->
        <v-layout column>
          <p>
            <b>{{ $translate("LOCATION_SQUARE_PER_PERSON") }}</b>
          </p>
          <!--          <v-radio-group @change="clearTheRadios" v-model="radios" :mandatory="true">-->
          <!--            <v-radio label="Max capacity" value="MaxCapacity"></v-radio>-->
          <!--            <v-radio label="Square meter per person" value="AreaPerPerson"></v-radio>-->
          <!--          </v-radio-group>-->
          <!--          <v-text-field v-if="radios == 'MaxCapacity'" v-model="form.selectedRadio" min="0" required label="Max capacity"></v-text-field>-->
          <v-text-field
            v-model="form.areaPerPerson"
            min="1"
            type="number"
            required
            :label="$translate('SQUARE_PER_PERSON')"
          ></v-text-field>
        </v-layout>
        <v-layout column wrap>
          <h4>{{ $translate("LOCATION_PICTURE") }}</h4>
          <LocationImageLoader
            class="imageBorder"
            :properties="pictureProperties"
            v-on:load_image="setImageElement"
          ></LocationImageLoader>
        </v-layout>
        <v-layout>
          <v-text-field
            v-model="form.street"
            :label="$translate('STREET')"
            required
            value="2"
          ></v-text-field>
          <v-text-field
            class="ml-2"
            v-model="form.postalCode"
            label="Post code"
            required
            value="2"
          ></v-text-field>
        </v-layout>
        <v-layout>
          <v-text-field
            v-model="form.city"
            :label="$translate('CITY')"
            required
            value="2"
          ></v-text-field>
          <v-text-field
            class="ml-2"
            v-model="form.nr"
            label="Nr"
            required
            value="2"
          ></v-text-field>
        </v-layout>
        <v-layout>
          <v-text-field
            v-model="form.country"
            :label="$translate('COUNTRY')"
            required
            value="2"
          ></v-text-field>
          <v-text-field
            class="ml-2"
            v-model="form.telephone"
            :label="$translate('TELEPHONE')"
            required
            value="2"
          ></v-text-field>
        </v-layout>
        <v-text-field
          v-model="form.publicTransportStops"
          :label="$translate('LOCATION_PUBLIC_TRANSPORT')"
          required
          value="2"
        ></v-text-field>
        <v-text-field
          v-model="form.website"
          :label="$translate('VRI_WEBSITE')"
          required
          value="2"
        ></v-text-field>
        <v-text-field
          v-model="form.email"
          :label="$translate('EMAIL')"
          type="email"
          required
          value="2"
        ></v-text-field>
        <v-text-field
          v-model="form.openingHours"
          type="text"
          :label="$translate('OPENING_HOURS')"
          required
          value="2"
        ></v-text-field>
        <v-layout>
          <v-autocomplete
            :disabled="$store.getters['auth/partnerId'] !== -1"
            v-model="form.partnerId"
            :items="partners"
            hide-no-data
            item-text="Name"
            item-value="PartnerId"
            :label="$translate('SEARCH')"
            prepend-icon="view_headline"
            :placeholder="$translate('PARTNERS')"
            @click="getPartners()"
            clearable
          />
        </v-layout>
        <v-layout justify-center align-center>
          <v-tooltip bottom>
            <v-btn
              round
              color="primary"
              slot="activator"
              @click="showPolylineHelper = true"
            >
              <v-icon dark>gesture</v-icon
              >{{ $translate("LOCATION_MARK_LOCATION") }}
            </v-btn>
            <span>{{ $translate("DEFINE_AREA") }}</span>
          </v-tooltip>
        </v-layout>
        <v-text-field
          v-model="form.polyline"
          :disabled="true"
          :label="$translate('LOCATION_BOUNDARIES')"
          :rules="textRule"
          required
          value="2"
        ></v-text-field>

        <v-layout>
          <v-text-field
            class="mr-1 ml-1"
            v-model="form.latitude"
            :label="$translate('LOCATION_LATITUDE')"
            :rules="coordRule"
            :disabled="true"
            required
            value="2"
          ></v-text-field>
          <v-text-field
            class="mr-1 ml-1"
            v-model="form.longitude"
            :label="$translate('LOCATION_LONGITUDE')"
            :rules="coordRule"
            :disabled="true"
            required
            value="2"
          ></v-text-field>

          <v-text-field
            class="mr-1 ml-1"
            v-model="form.geofenceRadius"
            :label="$translate('LOCATION_RADIUS')"
            required
            value="2"
          ></v-text-field>
        </v-layout>
        <v-select
          chips
          :label="$translate('LOCATION_USED_BY')"
          v-model="accountsSelected"
          :items="accounts"
          item-text="accountName"
          item-value="accountId"
          class="mr-2 ml-2"
          persistent-hint
          return-object
          deletable-chips
          clearable
          multiple
        ></v-select>
        <v-autocomplete
          @input="searchString = ''"
          @change="searchString = ''"
          v-model="partOfSelection"
          :items="partOfArray"
          :loading="isLoading"
          :search-input.sync="searchString"
          :rules="partOfRule"
          hide-no-data
          hide-selected
          item-text="name"
          item-value="locationId"
          :label="$translate('PART_OF')"
          clearable
          chip
          deletable-chips
          multiple
          :placeholder="$translate('SEARCH')"
          return-object
        >
          <template v-slot:selection="data">
            <v-chip
              :selected="data.selected"
              close
              @input="remove(data.item)"
              >{{ data.item.name }}</v-chip
            >
          </template>
        </v-autocomplete>

        <v-checkbox
          :label="$translate('LOCATION_ENTRY_POINT')"
          color="primary"
          hide-details
          v-model="entryTypeCheckbox"
        />
        <v-layout v-if="entryTypeCheckbox" column wrap>
          <v-flex xs12 sm6 md6>
            <v-radio-group v-model="form.entryType" column>
              <v-radio
                :label="$translate('LOCATION_ENTRY')"
                color="red"
                value="1"
              ></v-radio>
              <v-radio
                :label="$translate('LOCATION_EXIT')"
                color="red"
                value="2"
              ></v-radio>
              <v-radio
                :label="$translate('LOCATION_ENTRY/EXIT')"
                color="red"
                value="3"
              ></v-radio>
            </v-radio-group>

            <h3>{{ $translate("TRANSPORTATION") }}</h3>
            <v-select
              v-model="transportTypeSelected"
              :items="transportationFilter"
              item-text="description"
              item-value="tagId"
              class="mr-2 ml-2"
              clearable
              chip
              deletable-chips
              persistent-hint
              return-object
              multiple
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  close
                  @input="removeTransportationTag(data.item)"
                  >{{ data.item.description }}</v-chip
                >
              </template>
            </v-select>
          </v-flex>
        </v-layout>

        <v-flex xs12 class="mt-4">
          <h4>Map icon</h4>
          <v-select
            v-model="form.iconId"
            :items="mapIcons"
            item-text="Name"
            item-value="IconId"
            label="Choose a map icon"
            class="mt-2 mb-2"
            single-line
            outline
          >
            <template v-slot:selection="data">
              <v-layout row wrap justify-space-around>
                <v-flex>
                  {{ data.item.Name }}
                </v-flex>
                <v-avatar size="25px">
                  <v-img :src="data.item.GreenIcon" contain />
                </v-avatar>
                <v-avatar size="25px">
                  <v-img :src="data.item.YellowIcon" contain />
                </v-avatar>
                <v-avatar size="25px">
                  <v-img :src="data.item.RedIcon" contain />
                </v-avatar>
              </v-layout>
            </template>
            <template v-slot:item="data">
              <v-layout row wrap>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="data.item.Name"
                  ></v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-avatar size="35px">
                  <v-img :src="data.item.GreenIcon" contain />
                </v-list-tile-avatar>
                <v-list-tile-avatar size="35px">
                  <v-img :src="data.item.YellowIcon" contain />
                </v-list-tile-avatar>
                <v-list-tile-avatar size="35px">
                  <v-img :src="data.item.RedIcon" contain />
                </v-list-tile-avatar>
              </v-layout>
            </template>
          </v-select>
        </v-flex>

        <v-flex xs12 class="mt-3">
          <h4>{{ $translate("TAGS_CATEGORIES") }}</h4>
          <CategoriesTree
            v-if="locationCategoriesAll.length > 0"
            id="categoryForLocationCreation"
            :categoriesAll="locationCategoriesAll"
            v-on:categoriesSelected="setSelectedLocationCategories"
            class="mt-2 mb-4"
            :style="`border: 1px solid black; border-radius: 5px`"
          ></CategoriesTree>
          <v-layout justify-center align-center>
            <v-tooltip top>
              <v-btn
                round
                color="primary"
                :disabled="saveDisabled"
                slot="activator"
                @click="saveDefinetely"
                >{{ $translate("SAVE") }}</v-btn
              >
              <span>{{ $translate("SAVE_TOOLTIP") }}</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-form>
    <v-dialog v-model="errorDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{
          $translate("FORM_VALIDATE_1_TITLE")
        }}</v-card-title>
        <v-card-text>
          <li>{{ $translate("FORM_VALIDATE_1_BODY_1") }}</li>

          <li>{{ $translate("FORM_VALIDATE_1_BODY_2") }}</li>
          <li>{{ $translate("FORM_VALIDATE_1_BODY_5") }}</li>
          <div v-if="entryTypeCheckbox && transportTypeSelected.length == 0">
            {{ $translate("FORM_VALIDATE_1_BODY_3") }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="errorDialog = false">{{
            $translate("OK")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorDialogPolyline" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{
          $translate("FORM_VALIDATE_1_TITLE")
        }}</v-card-title>
        <v-card-text>{{ $translate("FORM_VALIDATE_1_BODY_4") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="errorDialogPolyline = false">{{
            $translate("OK")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPolylineHelper" persistent max-width="290">
      <v-card class="round_dialog_roles">
        <v-card-title class="headline">{{
          $translate("HELPER_DRAW_POLYLINE")
        }}</v-card-title>
        <v-card-text>{{ $translate("HELPER_DRAW_POLYLINE_2") }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" round @click="enableDrawPolyline">{{
            $translate("OK")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import ExpendableTags from "@/components/ExpendableTags";
import * as dssRequest from "../api/dssRequest";
import LocationObject from "../objects/LocationObject";
import OsmResult from "./OsmResult";
import appConfig from "../../config/app_config";
import BaseObject from "../objects/BaseObject";
import BaseComponent from "./base/BaseComponent.vue";
import { ui_helpers } from "../shared/ui_helpers";
import LocationImageLoader from "./media/LocationImageLoader";
import CategoriesTree from "@/components/CategoriesTree";

export default {
  extends: BaseComponent,
  name: "AddLocation",
  mixins: [ui_helpers],
  props: {
    properties: Object,
  },
  computed: {
    ...mapGetters({
      filters: "getFilterTags",
      selectedLocation: "getSelectedLocation",
      _selectedPartOfLocation: "getSelectedPartOfLocation",
    }),
  },
  watch: {
    entryTypeCheckbox(newV, oldV) {
      if (!oldV && newV) {
        this.form.entryType = "3";
      }
    },
    filters: {
      handler(changedFilter) {},
      deep: true,
    },
    searchString(e) {
      console.log("Lorenzo this.partOfSelection", this.partOfSelection);
      this.isLoading = true;
      this.getLocationInternally();
    },
  },
  components: {
    OsmResult,
    ExpendableTags,
    LocationImageLoader,
    CategoriesTree,
  },
  data() {
    return {
      partners: [],
      maxCharRule: "Max 25 characters",
      // radios: 'AreaPerPerson',
      preselection: [],
      expTagProp: {},
      disableExpTag: false,
      accounts: [],
      accountsSelected: [],
      showPolylineHelper: false,
      saveDisabled: false,
      searchString: "",
      isLoading: false,
      errorDialog: false,
      textRule: [
        (v) => !!v || "Field is required",
        (v) => v != 0 || "Field must at least be 1 char long!",
      ],
      partOfRule: [(v) => !!v || "A location is required"],
      coordRule: [
        (v) => !!v || "Field is required",
        (v) => v !== 0 || "Field must be different from 0!",
      ],
      transportTypeSelected: [],
      recievedEntryTypeForEditing: "",
      transportationFilter: [],
      internalFilter: null,
      entryTypeCheckbox: false,
      showOsmResult: false,
      searchingOsm: false,
      errorDialogPolyline: false,
      validationDialog: false,
      partOfSelection: [],
      partOfArray: [],
      query_tags: "",
      osmType: "way",
      setSubSearch: true,
      searchedLocations: [],
      loadingButton: false,
      loading: false,
      form: this.properties.hasOwnProperty("location")
        ? this.properties.location
        : LocationObject._objectDefinition(),
      editMode: false,
      disableCalendar: true,
      pictureProperties: {
        title: "Background",
        signalName: "load_image",
        deletable: false,
        pictureUrl: "",
        maxWidth: appConfig.maxSize.home.w,
        maxHeight: appConfig.maxSize.home.h,
        scale: "w",
      },
      mapIcons: [],
      locationCategoriesAll: [],
      locationCategoriesSelected: [],
    };
  },
  created() {
    console.log("Brian this.form on created", this.form);
    if (
      this.editMode == true &&
      this.properties.params.location.hasOwnProperty("entryType")
    ) {
      this.recievedEntryTypeForEditing = this.properties.params.location.entryType;
    }
    this.internalFilter = this.filters.filter(
      (l) => l.title != "Transportation"
    );

    this.editMode = this.properties.type == "edit";
    if (this.editMode === true) {
      this.disableCalendar = false;
      if (!_.isEmpty(this.form.memberOf)) {
        this.form.members = BaseObject._createArrayWithObjects(
          this.form.memberOf.accountsForLocation
        );
        this.form.members.forEach((e) => {
          if (
            e.accountId !== this.currentAccountId &&
            e.grantType === "VISIBLE"
          )
            this.accountsSelected.push(e);
        });
      }
      // set the image picture
      // this.pictureProperties.pictureUrl = this.form.picture; // old way

      this.getLocationImg(this.form.id);
      if (!_.isEmpty(this.form.tags)) {
        for (const [k, v] of Object.entries(this.form.tags)) {
          for (const [k1, v1] of Object.entries(v)) {
            if (k == "Transportation") {
              this.transportTypeSelected.push(
                BaseObject._toLowerCaseObjectProperties(v1)
              );
            } else {
              v1.Selected = "yes";
              this.preselection.push(v1);
            }
          }
        }
      }
      if (!_.isEmpty(this.form.containers)) {
        // for (let [k, v] of Object.entries(this.form.containers)) {
        //   let o = {
        //     locationId: k[0].toUpperCase() + k.substring(1, k.length),
        //     name: v.containerName,
        //     selected: true,
        //     depth: v.depth
        //   };

        //   this.partOfArray.push(o);
        //   this.partOfSelection.push(o);
        //   this.properties.params.partOf.selected = true;
        // }
        Object.entries(this.form.containers).forEach(([k, v]) => {
          const o = {
            locationId: k[0].toUpperCase() + k.substring(1, k.length),
            name: v.hasOwnProperty("containerName")
              ? v.containerName
              : v.ContainerName,
            selected: true,
            depth: v.hasOwnProperty("depth") ? v.depth : v.Depth,
          };

          this.partOfArray.push(o);
          this.partOfSelection.push(o);
          this.properties.params.partOf.selected = true;
        });
      }
    } else if (!_.isEmpty(this.properties.params.partOf)) {
      this.properties.params.partOf.selected = true;
      this.partOfArray.push(this.properties.params.partOf);
      this.partOfSelection.push(this.properties.params.partOf);
    }

    // Load location categories
    if (this.editMode === true) {
      if (
        this.form.hasOwnProperty("categories") &&
        this.form.categories !== undefined
      ) {
        this.locationCategoriesAll = [];
        this.locationCategoriesAll = [...this.form.categories];
      }
    } else {
      this.getAllLocationCategories();
    }

    // Map icons
    if (
      this.properties.params.hasOwnProperty("mapIcons") &&
      this.properties.params.mapIcons !== undefined
    ) {
      this.mapIcons = [];
      this.mapIcons = [...this.properties.params.mapIcons];
    }

    if (this.form.entryType > 0) {
      this.entryTypeCheckbox = true;
    }
    // registering listeners for the component
    window.EventBus.listen("clickedLocation", this.addCenterPoint);
    window.EventBus.listen(
      "clickedLocationDestination",
      this.clickedLocationOnPlainMap
    );
    window.EventBus.listen("setSelectedLocation", this.setSelectedLocation);

    this.getTransportationTags();
    this.getAccounts();
  },
  mounted() {
    this.getPartners();
    this.getLocationInternally(true);
  },
  beforeDestroy() {
    window.EventBus.removeListener("clickedLocation", this.addCenterPoint);
    window.EventBus.removeListener(
      "clickedLocationDestination",
      this.clickedLocationOnPlainMap
    );
    window.EventBus.removeListener(
      "setSelectedLocation",
      this.setSelectedLocation
    );
  },
  methods: {
    /**
     * function to parse the replied property Matrix
     * in one array of objects, all the columns will
     * be object properties,
     * the celldata property is an object instead of an array
     */

    clearTheRadios() {
      this.$refs.form.selectedRadio = "";
      this.form.selectedRadio = "";
    },
    parseObject(reply) {
      const outputArray = [];
      const cellData = reply.celldata;

      for (const [k, v] of Object.entries(cellData)) {
        const translateObj = this.parseStructToObject(v, reply.columns);
        outputArray.push(translateObj);
      }
      return outputArray;
    },
    /**
     * internal function to create object property
     * from columns
     */
    parseStructToObject(data, columns) {
      const object = {};

      for (const p in columns) {
        if (columns.hasOwnProperty(p)) {
          const index = columns[p];
          switch (p) {
            default:
              object[p] = data[index];
          }
        }
      }
      return object;
    },
    goToLocations() {
      const item = {
        title: "Locations",
        selected: true,
        link: {
          main: "Locations_Main",
          side: "NavigationOverview",
        },
      };
      this.showComponents(item.link);
    },
    goBack() {
      this.showComponents({
        main: "Locations_Main",
        side: "NavigationOverview",
        mainParams: null,
        sideParam: null,
      });
    },
    setSelectedTags(data) {
      this.form.tags = data;
    },
    removeTransportationTag(item) {
      const index = this.transportTypeSelected.findIndex(
        (l) => l.tagId == item.tagId
      );
      if (index >= 0) this.transportTypeSelected.splice(index, 1);
    },
    remove(item) {
      const index = this.partOfSelection.findIndex(
        (l) => l.locationId == item.locationId
      );
      if (index >= 0) this.partOfSelection.splice(index, 1);
    },
    getTransportationTags() {
      // this used to be the call getAllTransportationTags on CommunicationWithDBLibrary
      const payload = {
        FunctionId: "dbAction",
        Action: "SELECT",
        ReplyName: "AllTransportTags",
        TableName: "config.TagDef",
        Columns: {
          Type: "System",
          TagGroup: "Transportation",
          AccountId: "0",
        },
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getAllTransportationTags was successful",
            response
          );

          for (
            let i = 0;
            i < response.data.AllTransportTags.celldata.length;
            i++
          ) {
            if (
              response.data.AllTransportTags.celldata[i][1] ==
              response.data.AllTransportTags.celldata[i][2]
            ) {
              response.data.AllTransportTags.celldata.splice(i, 1);
              break;
            }
          }
          this.transportationFilter = BaseObject._toLowerCaseInitialProperty(
            BaseObject._createArrayWithObjects(response.data.AllTransportTags)
          );
        },
        (error) => {
          console.log(
            "The generic call call getAllTransportationTags was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload
      );
    },
    getAccounts() {
      // This used to be the function getAccount on CommmunicateWithDBLibrary
      this.accounts = [];
      const payload = {
        FunctionId: "dbAction",
        Action: "SELECT",
        ReplyName: "Account",
        TableName: "config.Account",
        Columns: {},
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The generic call getAccount was successful", response);
          const tmpAccounts = BaseObject._toLowerCaseInitialProperty(
            BaseObject._createArrayWithObjects(response.data.Account)
          );
          tmpAccounts.sort((a, b) =>
            a.accountName.localeCompare(b.accountName, "en", {
              sensitivity: "base",
            })
          );
          tmpAccounts.forEach((e) => {
            if (e.accountId != this.currentAccountId) this.accounts.push(e);
          });
        },
        (error) => {
          console.log("The generic call getAccount was not successful", error);
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload
      );
    },
    setSelectedLocation(location) {
      this.form = location;
    },
    enableDrawPolyline() {
      window.EventBus.fire("rightClickSelectBehaviour", 3);
      this.showPolylineHelper = false;
    },
    addCenterPoint(clickedLocation) {
      this.form.latitude = clickedLocation.decimal[1];
      this.form.longitude = clickedLocation.decimal[0];
      if (
        _.isEmpty(this.properties.params) ||
        this.properties.params.partOf.selected === false
      ) {
        // search for partOf
        this.partOfArray = [];
        const payload = LocationObject._createGetContainerRequest(this.form);
        dssRequest.doRequest(
          (response) => {
            console.log(
              "The call for getContainerLocations was successful",
              response
            );
            const data = LocationObject._parseLocationsInPropertyMatrix(
              response.data.Locations
            );
            this.partOfArray = data.filter(
              (l) => l.locationId != this.form.locationId
            );
          },
          (error) => {
            console.log(
              "The call for getContainerLocations was not successful",
              error
            );
          },
          "getContainerLocations",
          appConfig.dss.locationMgr,
          payload
        );
      }
    },
    getLocationImg(locationId) {
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log("The call getLocationImg was successful", response);
          if (
            response.data.Picture !== null &&
            response.data.Picture !== "" &&
            response.data.Picture !== "NULL"
          ) {
            // this.popupImg = true;
            this.pictureProperties.pictureUrl = response.data.Picture;
          } else {
            this.pictureProperties.pictureUrl = "";
          }
        },
        (error) => {
          console.log("The call getLocationImg was not successful", error);
        },
        "getLocationPicture",
        locationId,
        payload
      );
    },
    clickedLocationOnPlainMap(gps) {
      this.form.polyline = gps.coordinates.map((e) => e).join(" ");
    },
    searchOSRM() {
      this.searchingOsm = true;
      this.searchedLocations = [];
      const payload = {
        Name: this.form.name,
        Tags: this.query_tags,
        Type: this.osmType,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "This the call for searchLocationsInOSM was successful",
            response
          );
          const res = response.data;
          this.searchingOsm = false;
          this.showOsmResult = true;

          for (const [key, value] of Object.entries(res)) {
            const tmp = LocationObject._parseOsmObject(value);
            this.searchedLocations.push(tmp);
          }
          this.searchedLocations.sort((a, b) =>
            a.name.localeCompare(b.locationName, "en", {
              sensitivity: "base",
            })
          );
        },
        (error) => {
          console.log(
            "The call for searchLocationsInOSM was not successful",
            error
          );
          this.searchingOsm = false;
        },
        "searchLocationsInOSM",
        appConfig.dss.locationMgr,
        payload,
        600000
      );
    },
    getPartners() {
      // Action for loading all the Partners in the current account
      const payload = {
        FunctionId: "AccountFunctionLibrary::getPartners",
      };
      dssRequest.doRequest(
        (response) => {
          console.log("the call for getPartners was successful", response);
          // Clear the current partners array
          this.partners = [];
          // Insert PartnerId to each partner object
          for (const [k, v] of Object.entries(response.data.Partners)) {
            if (!v.ExternalEventBridges.hasOwnProperty("Formitable")) {
              v.ExternalEventBridges.Formitable = {
                ApiKey: "",
              };
            }
            if (!v.ExternalEventBridges.hasOwnProperty("TicketCounter")) {
              v.ExternalEventBridges.TicketCounter = {
                ClientId: "",
                ClientSecret: "",
                Username: "",
                Password: "",
                RefreshToken: "",
              };
            }
            this.partners.push({ PartnerId: Number(k), ...v });
          }

          if (this.$store.getters["auth/partnerId"] !== -1) {
            this.partners.forEach((partner) => {
              console.log(
                "Brian partner",
                partner.PartnerId,
                this.$store.getters["auth/partnerId"]
              );
              if (partner.PartnerId == this.$store.getters["auth/partnerId"]) {
                console.log("Brian partner", partner);
                this.form.partnerId = partner;
              }
            });
          }
        },
        (error) => {
          console.log("the call for getPartners was not successful", error);
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    },
    saveDefinetely() {
      console.log("Brian this.form", this.form);

      if (this.form.email !== "" && !this.form.email.includes("@")) {
        this.errorDialog = true;
        return;
      }

      if (this.entryTypeCheckbox == false) {
        this.form.entryType = "0";
        this.saveDisabled = false;
      }

      if (!this.$refs.form.validate()) {
      }
      if (
        (this.entryTypeCheckbox && Number(this.form.entryType) == 0) ||
        (Number(this.form.entryType) != 0 &&
          this.transportTypeSelected.length === 0)
      ) {
        this.errorDialog = true;
        return;
      }

      // if (this.radios == 'MaxCapacity') {
      //   this.form.maxCapacity = Number(this.form.selectedRadio);
      // } else if (this.radios == 'AreaPerPerson') {
      //   this.form.areaPerPerson = Number(this.form.selectedRadio).toFixed(2);
      // }

      if (
        this.partOfSelection === undefined ||
        (this.partOfSelection != undefined && this.partOfSelection.length == 0)
      ) {
        this.errorDialog = true;
        return;
      }

      if (this.form.polyline.length > 4095) {
        this.errorDialogPolyline = true;
        return;
      }

      this.form.picture = this.pictureProperties.pictureUrl;

      // Mapping transportation tags as expected grouped
      const o = { Transportation: {} };
      this.transportTypeSelected.forEach((t) => {
        o.Transportation[t.tagId] = t.tagId;
      });
      this.form.tags = Object.assign(this.form.tags, o);

      // this.form.container = this.partOfSelection;
      this.form.containers = { ...this.partOfSelection };

      const payload = LocationObject._createRequestObject(
        this.form,
        this.accountsSelected
      );
      this.validationDialog = false;
      console.log("Brian this.editMode", this.editMode);

      // Add selected categories to payload
      payload.Categories = [];
      this.locationCategoriesSelected.forEach((category) => {
        payload.Categories.push(category.InterestId);
      });

      if (!this.editMode) {
        dssRequest.doRequest(
          (response) => {
            console.log("The call for saveLocation was successful", response);
            this.saveDisabled = true;
            this.disableCalendar = false;
            this.form.locationId = response.data.LocationId;
            const toSendObject = {};
            toSendObject.locationId = response.data.LocationId;
            window.EventBus.fire(
              "activateSnackBar",
              this.$translate("LOCATION_CREATION_OK")
            );
            this.goToLocations();
            setTimeout(() => {
              window.EventBus.fire("getLocationTranslations", toSendObject);
            }, 1000);
          },
          (error) => {
            console.log("The call for saveLocation was not successful", error);
            this.saveDisabled = false;
          },
          "saveLocation",
          appConfig.dss.locationMgr,
          payload
        );
      } else {
        dssRequest.doRequest(
          (response) => {
            this.saveDisabled = true;
            console.log("The call for editLocation was successful", response);
            this.saveDisabled = false;
            window.EventBus.fire(
              "activateSnackBar",
              this.$translate("LOCATION_EDITING_OK")
            );
          },
          (error) => {
            this.saveDisabled = false;
            console.log("The call for editLocation was not successful", error);
          },
          "editLocation",
          this.form.id,
          payload
        );
      }
    },
    getLocationInternally(getOnStart = false) {
      const payload = {
        PartnerId: this.$store.getters["auth/partnerId"],
        Name: this.searchString,
        FunctionId: "LocationFunctionLibrary::getLocationsV2",
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call for 'getLocationsV2' on - AddLocation.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty("Locations")) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
            return;
          }
          if (response.data.Locations !== undefined) {
            this.partOfArray = LocationObject._createArrayWithObjects(
              response.data.Locations
            );
          }
          if (this.partOfSelection.length === 0) {
            for (const [index, item] of Object.entries(this.partOfArray)) {
              if (
                item.locationId === this.$store.getters.getMainLocationId &&
                getOnStart
              ) {
                console.log("Lorenzo index, item", index, item);
                this.partOfSelection.push(item);
              }
            }
          }
          this.isLoading = false;
        },
        (error) => {
          console.log(
            "The generic call for 'getLocationsV2' on - AddLocation.vue - was not successful",
            error
          );
          this.isLoading = false;
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload,
        600000,
        false
      );
    },
    setImageElement(e) {
      if (e.signalName == this.pictureProperties.signalName) {
        this.pictureProperties.pictureUrl = e.url;
      }
    },
    getAllLocationCategories() {
      const payload = {
        LanguageTagId: this.$store.getters.getUserLanguage,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getInterestsForLocation] on [LocationsNode_ISE] in component [AddLocation] succeeded",
            response
          );
          this.locationCategoriesAll = [];
          if (
            response.data.hasOwnProperty("Interests") &&
            response.data.Interests !== undefined
          ) {
            this.locationCategoriesAll = [...response.data.Interests];
          }
        },
        (error) => {
          console.log(
            "The call [getInterestsForLocation] on [LocationsNode_ISE] in component [AddLocation] failed",
            error
          );
        },
        "getInterestsForLocation",
        "LocationsNode_ISE",
        payload
      );
    },
    setSelectedLocationCategories(categoriesSelected) {
      this.locationCategoriesSelected = [];
      this.locationCategoriesSelected = [...categoriesSelected];
    },
  },
};
</script>

<style scoped lang="scss">
.v-btn-2 {
  min-width: 1em;
}
.outline-osm {
  border: 2px solid #c0c0c0 !important;
}
.scrollList-addLocation {
  width: 100%;
  height: 80vh;
  overflow-x: hidden;
  overflow-y: auto;
}
.v-progress-circular {
  margin: 1rem;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

.imageBorder {
  padding-right: 1em;
  padding-left: 1em !important;
  margin-bottom: 1.5em;
  margin-top: 0.1em;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
